import { render, staticRenderFns } from "./multipleResult.vue?vue&type=template&id=700dd67d&scoped=true&"
import script from "./multipleResult.vue?vue&type=script&lang=js&"
export * from "./multipleResult.vue?vue&type=script&lang=js&"
import style0 from "./multipleResult.vue?vue&type=style&index=0&id=700dd67d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700dd67d",
  null
  
)

export default component.exports